import React from "react";
import { IResource } from "@gettactic/api";
import { useMap } from "@webV2/map/MapProvider";
import { useBooleanState } from "@gettactic/helpers";
import { SvgMiniMap } from "@gettactic/map-builder/src/components/map/MapCanvas/SvgMiniMap";
import { UseSvgMapInteractionsReturn } from "@gettactic/helpers/src/map/svg/useSvgMapInteractions";
import { createPortal } from "react-dom";

export interface MapViewSvgMiniMapProps {
  mapInteractor: UseSvgMapInteractionsReturn;
  width?: number;
  height?: number;
  disableOnFocus?: boolean;
}

export const MapViewSvgMiniMap: React.FC<MapViewSvgMiniMapProps> = ({
  mapInteractor,
  width,
  height,
  disableOnFocus = true
}) => {
  const { events, startDate, floor, currentOffice } = useMap();

  const isDisabled = useBooleanState(false);

  React.useEffect(() => {
    if (!disableOnFocus) return;

    const onFocusResource = (resource: IResource | null) => {
      if (!resource) {
        isDisabled.false();
        return;
      }

      isDisabled.true();
    };
    events.register("onFocusResource", onFocusResource);

    return () => {
      events.unregister("onFocusResource", onFocusResource);
    };
  }, [startDate, floor, currentOffice, disableOnFocus]);

  return createPortal(
    <SvgMiniMap
      mapInteractor={mapInteractor}
      disabled={isDisabled.state}
      width={width}
      height={height}
    />,
    window.document.body
  );
};
